import { AssetStoryblok, LinkStoryblok, MultilinkStoryblok } from '@/types/storyblok/storyblok-types';
import { fixDuplicateLanguagePath } from './helper';

export function parseStoryblokUrl(url: string) {
    let parsedUrl = fixDuplicateLanguagePath(url);

    if (!parsedUrl.startsWith('/')) {
        parsedUrl = `/${parsedUrl ?? 'en'}`;
    }

    if (!parsedUrl.endsWith('/')) {
        parsedUrl += '/';
    }

    return parsedUrl;
}

export function parseStoryblokLinkObject(link: AssetStoryblok | LinkStoryblok | MultilinkStoryblok) {
    if (link.linktype === 'url' || link.linktype === 'asset') {
        const { cached_url: url } = link;

        if (!url.startsWith('https://')) {
            if (url.startsWith('www.')) {
                return `https://${fixDuplicateLanguagePath(url)}`;
            }
            return `https://www.${fixDuplicateLanguagePath(url)}`;
        }
        return url;
    }

    return parseStoryblokUrl(link.cached_url);
}

export const createQueryString = (searchParams, name: string, value: string) => {
    const params = new URLSearchParams(searchParams);
    params.set(name, value);

    return params.toString();
};

export const localizePrice = (price?: number, { decimals = 0, alwaysPositive = false } = {}) => {
    let newPrice = price ?? 0;
    newPrice = (alwaysPositive ? Math.abs(newPrice) : newPrice) || 0;
    return newPrice.toLocaleString('de-CH', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

export const localizePriceCurrency = (
    price: number,
    defaultCurrency: string,
    currency: string,
    locale: string,
    {
        exchangeRate = 1,
        decimals = 0,
        alwaysPositive = false,
    }: {
        exchangeRate?: number;
        decimals?: number;
        alwaysPositive?: boolean;
    } = {},
) => {
    let newPrice = Number(price) ?? 0;
    newPrice = alwaysPositive ? Math.abs(newPrice) : newPrice;

    const convertedPrice = newPrice * exchangeRate;

    return {
        default: new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: defaultCurrency,
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        }).format(newPrice),

        converted: new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        }).format(convertedPrice),
    };
};

// Storyblok docs for filter queries
// https://www.storyblok.com/docs/api/content-delivery/v2#filter-queries/overview
export enum StoryblokFilterOperation {
    IS = 'is',
    IN = 'in',
    NOT_IN = 'not_in',
    LIKE = 'like',
    NOT_LIKE = 'not_like',
    ANY_IN_ARRAY = 'any_in_array',
    ALL_IN_ARRAY = 'all_in_array',
    GT_DATE = 'gt_date',
    LT_DATE = 'lt_date',
    GT_INT = 'gt_int',
    LT_INT = 'lt_int',
    GT_FLOAT = 'gt_float',
    LT_FLOAT = 'lt_float',
}
